import { FolioRevenueReport, GetFolioRevenueReport } from 'services/api/type/report.type';
import { useQuery } from '@tanstack/react-query';
import API from 'services/api/index';
import QUERY_KEYS from 'services/api/queryKeys';
import { PaginationType } from 'services/api/type/booking.type';
import { PAGE_SIZE_FOLIO_REVENUE_REPORT } from 'services/api/module/report.api';
import get from 'lodash/get';

export const useGetFolioRevenueReport = (
  filterOptions: GetFolioRevenueReport,
  page: number,
  pageSize: number = PAGE_SIZE_FOLIO_REVENUE_REPORT
) => {
  const { data, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.GET_FOLIO_REVENUE_REPORT, page, filterOptions],
    queryFn: () => API.report.folioRevenueReport({ ...filterOptions, page, limit: pageSize }),
    enabled: !!filterOptions
  });

  return {
    data: get(data, 'data', []) as FolioRevenueReport[],
    pagination: get(data, 'pagination', {}) as PaginationType,
    isFetching
  };
};

export const useGetFolioRevenueReportForExport = (
  filterOptions: GetFolioRevenueReport,
  enable: boolean = false
) => {
  const { data, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.GET_FOLIO_REVENUE_REPORT, filterOptions],
    queryFn: () => API.report.folioRevenueReport(filterOptions),
    enabled: enable
  });

  return {
    data: get(data, 'data', []) as FolioRevenueReport[],
    pagination: get(data, 'pagination', {}) as PaginationType,
    isFetching
  };
};
